// 按时间统计
import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts';
import dayjs from 'dayjs';

export default function Time({ dataSource, unit }) {
    const timeEcharts = useRef()
    useEffect(() => {
        if (dataSource && dataSource.length > 0) {
            // if (true) {
            // let myChart = echarts.init(document.getElementById('zhuMy'))
            let chartDom = timeEcharts.current
            if (chartDom) {

                let myChart = echarts.init(chartDom)
                let zhuD = []

                // 按时间统计（按日）

                dataSource.forEach(item => {
                    // 判断是否存在该日
                    const index = zhuD.findIndex(it => dayjs(it.name).format('YYYY-MM-DD') === dayjs(item.satelliteTime).format('YYYY-MM-DD'))
                    if (index > -1) {
                        // zhuD.push({
                        //     name: dayjs(item.satelliteTime).format('YYYY-MM-DD'),
                        //     value: []
                        // })
                        zhuD[index].value.push(item)
                    } else {
                        zhuD.push({
                            name: dayjs(item.satelliteTime).format('YYYY-MM-DD'),
                            value: [item]
                        })
                    }
                })

                let option = {
                    // backgroundColor: "#323a5e",
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                        confine: true,//将tooltip限制在dom内
                        formatter: '{b0}: {c0} 处',
                        // backgroundColor: "rgba(0, 57, 115, 0.8)",
                        // borderColor: 'rgba(38, 147, 255, 0.6)',
                        backgroundColor: "rgba(20, 49, 68, 0.99)",
                        borderColor: 'rgba(37, 211, 190, 1)',
                        textStyle: {
                            color: 'white'
                        },
                        // { offset: 0, color: 'rgba(37, 211, 190, 1) ' },
                        // { offset: 1, color: ' rgba(20, 49, 68, 0.31)' }
                    },
                    grid: {
                        left: "2%",
                        right: "4%",
                        bottom: "14%",
                        top: "16%",
                        containLabel: true, //grid 区域是否包含坐标轴的刻度标签。
                    },
                    legend: {
                        right: 10,
                        top: 12,
                        textStyle: {
                            color: "#fff",
                        },
                        itemWidth: 12,
                        itemHeight: 10,
                        // itemGap: 35
                    },
                    xAxis: {
                        type: "category",
                        data: zhuD.map(item => item.name),
                        axisLine: {
                            lineStyle: {
                                color: "white",
                            },
                        },
                        axisLabel: {
                            // interval: 0,
                            // rotate: 40,
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                            },
                        },
                    },

                    yAxis: {
                        type: "value",
                        name: unit ? unit : '', //y轴名称
                        nameLocation: 'end', //y轴位置  'start'、'middle' 或者 'center'、 'end'
                        nameTextStyle: { //坐标轴字体
                            // color: "#6e7079",
                            align: 'center',
                        },
                        //   max: "1200",
                        axisLine: { //y轴
                            show: true,
                            lineStyle: {
                                color: "rgba(255,255,255,0.8)",
                            },
                        },

                        splitLine: { //y值中间延申 的刻度线
                            show: true,
                            lineStyle: {
                                type: "dashed",
                                color: "rgba(255,255,255,0.3)",
                            },
                        },
                        axisLabel: { //轴上刻度
                            //   formatter: "{value}",
                            //   formatter: function (value) {
                            //     let num = value
                            //     if (typeof value === 'number') {
                            //       num = parseFloat(value.toFixed(2))
                            //     }
                            //     return num
                            //   },
                            //   color: "#6e7079",
                            //   fontSize: 12,
                        },
                    },
                    dataZoom: [
                        {
                            show: true,
                            height: 12,
                            xAxisIndex: [0],
                            bottom: "8%",
                            start: 0,
                            end: 90,
                            handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
                            handleSize: "110%",
                            handleStyle: {
                                color: "#d3dee5",
                            },
                            textStyle: {
                                color: "#fff",
                            },
                            borderColor: "#90979c",
                        },
                        // {
                        //     type: "inside",
                        //     show: true,
                        //     height: 15,
                        //     start: 1,
                        //     end: 100,
                        // },
                    ],

                    series: [{
                        type: "bar",
                        barWidth: "15%",
                        itemStyle: {
                            normal: {
                                // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                //     offset: 0,
                                //     color: "#fccb05",
                                // },
                                // {
                                //     offset: 1,
                                //     color: "#f5804d",
                                // },
                                // ]),
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    { offset: 0, color: 'rgba(37, 211, 190, 1) ' },
                                    // { offset: 0.5, color: '#188df0' },
                                    { offset: 1, color: ' rgba(20, 49, 68, 0.31)' }
                                ]),
                                barBorderRadius: 12,
                            },
                        },
                        // data: [400, 400, 300, 300, 300, 400, 400, 400, 300],
                        data: zhuD.map(item => item.value.length),
                    },
                    ],
                };

                var app = {
                    currentIndex: -1,
                };
                setInterval(function () {
                    var dataLen = option.series[0].data.length;

                    // 取消之前高亮的图形
                    myChart.dispatchAction({
                        type: "downplay",
                        seriesIndex: 0,
                        dataIndex: app.currentIndex,
                    });
                    app.currentIndex = (app.currentIndex + 1) % dataLen;
                    // 高亮当前图形
                    myChart.dispatchAction({
                        type: "highlight",
                        seriesIndex: 0,
                        dataIndex: app.currentIndex,
                    });
                    // 显示 tooltip
                    myChart.dispatchAction({
                        type: "showTip",
                        seriesIndex: 0,
                        dataIndex: app.currentIndex,
                    });
                }, 1000);

                myChart.setOption(option)
                window.addEventListener("resize", () => {
                    myChart.resize();
                    // sheshiChart.resize();
                });
            }
        }
// eslint-disable-next-line
    }, [dataSource])

    return (
        <div ref={timeEcharts} style={{ width: '100%', height: "100%" }}></div>
    )
}